import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=0c7593ca&scoped=true&"
import script from "./GoodsList.vue?vue&type=script&lang=js&"
export * from "./GoodsList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=0c7593ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7593ca",
  null
  
)

component.options.__file = "src/components/goods/GoodsList.vue"
export default component.exports